import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
// import { get } from 'lodash'
import { connect } from 'react-redux'
import { Select } from 'components/fields'
import { Button } from 'components/misc'
import { Title, Section } from 'components/layout'
import { awardAllowedLevelsSelector } from 'redux/selectors/awards'
import { form } from 'helpers/decorators'
import { apiAwards } from 'helpers/decorators/api'

@apiAwards()
@form({
  form: 'form-change-award-level',
  disableHook: true
})
@connect(({ api }) => ({
  allowedAwardLevels: awardAllowedLevelsSelector(api.awards.allowedLevels)
}))
class AwardChange extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    currentAwardLevel: PropTypes.object.isRequired,
    fetchAllowedAwardLevels: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    changeAwardLevel: PropTypes.func.isRequired,
    allowedAwardLevels: PropTypes.array,
    values: PropTypes.object,
    submitting: PropTypes.bool,
    awardId: PropTypes.number.isRequired
  }

  static defaultProps = {
    values: {},
    currentAwardLevel: {}
  }

  state = {
    isLoading: true
  }

  componentDidMount = () => {
    const { awardId } = this.props

    this.props
      .fetchAllowedAwardLevels(awardId)
      .then(() => {
        this.setState({
          isLoading: false
        })
      })
      .catch(() => {
        this.setState({
          isLoading: false
        })
      })
  }

  render() {
    const {
      awardId,
      allowedAwardLevels,
      handleSubmit,
      values,
      submitting,
      currentAwardLevel
    } = this.props
    const { isLoading } = this.state

    const filterAllowedAwardLevels = allowedAwardLevels.filter(
      item => item.value !== currentAwardLevel.value
    )

    const hasOptions = filterAllowedAwardLevels.length > 0

    return (
      <Section loading={isLoading} inModal>
        <form
          onSubmit={handleSubmit(fields =>
            this.props.changeAwardLevel(awardId, fields)
          )}
        >
          {!hasOptions &&
            !isLoading && (
              <Title h3 intlKey="label.cannot_be_change_to_another">
                Cannot be changed to another award level
              </Title>
            )}
          {hasOptions && (
            <Select
              label="Allowed award levels"
              name="newLevel"
              options={filterAllowedAwardLevels}
            />
          )}

          <div className="row">
            {!isLoading && (
              <div className="col-xs-6">
                <Button
                  type="button"
                  intlKey="button.cancel"
                  onClick={this.props.onClose}
                  secondary
                >
                  Cancel
                </Button>
              </div>
            )}
            {hasOptions > 0 && (
              <div className="col-xs-6 text--right">
                <Button
                  intlKey="button.change"
                  disabled={!values.newLevel}
                  isLoading={submitting}
                >
                  Change
                </Button>
              </div>
            )}
          </div>
        </form>
      </Section>
    )
  }
}

export default AwardChange
